import React, {useEffect} from 'react';
import './App.css';
import {HomePage} from './screens/HomePage';
import {IosPrivacyPage} from './screens/IosPrivacyPage';
import {SupportPage} from './screens/SupportPage';
import {getAppRoute, isIosPrivacyRoute, isSupportRoute} from './routes';
import {applyRouteSeo, getRouteSeo} from './seo/routeSeo';

function App() {
  const appStoreUrl = '#';
  const appIconUrl = `${process.env.PUBLIC_URL}/logo192.png`;
  const appRoute = getAppRoute(window.location.pathname);
  const supportRouteActive = isSupportRoute(appRoute);
  const iosPrivacyRouteActive = isIosPrivacyRoute(appRoute);
  const routeSeo = getRouteSeo(appRoute);

  useEffect(() => {
    applyRouteSeo(routeSeo);
  }, [routeSeo]);

  if (supportRouteActive) {
    return <SupportPage appIconUrl={appIconUrl} appStoreUrl={appStoreUrl} />;
  }

  if (iosPrivacyRouteActive) {
    return <IosPrivacyPage appIconUrl={appIconUrl} appStoreUrl={appStoreUrl} />;
  }

  return <HomePage appIconUrl={appIconUrl} appStoreUrl={appStoreUrl} />;
}

export default App;
